<template>
  <v-container fluid>
    <v-row dense no-gutters>
      <v-col cols="12">
        <v-container fluid>
          <v-layout align-center justify-center>
            <v-flex sm12 md10 lg10>
              <v-card class="elevation-0"  outlined>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" class="text-center">
                      <img src="@/assets/images/logo_.png" class="team-img pt-8" alt="Creditoria"/>
                    </v-col>
                    <v-col cols="12" class="px-10">
                      <v-form ref="form">
                        <v-text-field v-model="session.usuario" label="Usuario" hint="Ingrese su Usuario o Correo"
                          :rules="fieldRequired" solo required/>
                        <v-text-field
                          v-model="session.password"
                          label="Contraseña"
                          :append-icon="showeye ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (value = !value)"
                          :rules="fieldRequired"
                          :type="showeye ? 'text' : 'password'"
                          @click:append="showeye = !showeye"
                          @keyup.enter="login"
                          solo
                          required/>
                      </v-form>
                      <v-btn :disabled="!valid" color="#026270" @click="login" dark block>Iniciar Sesión</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                    <v-progress-linear v-if="loading" color="#d68110" height="15" bottom indeterminate></v-progress-linear>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-col>
      <v-col cols="12" sm="6" md="6"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  name: 'login',
  mixins: [Validate],
  props: {
    source: String
  },
  data: () => ({
    valid: true,
    showeye: false,
    loger: null,
    session: {},
    loading: false
  }),

  methods: {
    ...mapActions(['PostServiceLogin']),
    login () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.PostServiceLogin({ url: '/login', data: this.session })
      }
    },
    precalificar () {
      router.push({ name: 'PrecalificadorGralDatosView' })
    }
  },
  computed: {
    ...mapGetters(['get_objectAccess'])
  },
  watch: {
    get_objectAccess (val) {
      this.loading = false
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
      }
      this.$cookies.set('token_cred', val.access_token)
      localStorage.setItem('permisos', JSON.stringify(val.user.roles[0]))
      const user = { id: val.user.id, email: val.user.correo, nombre: val.user.nombre, usuario: val.user.usuario }
      this.$cookies.set('user', user)
      router.push({ name: 'home' })
    }
  }
}
</script>

<style scoped lang="css">
.team-img {
  width: 40%;
}
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.content{
  margin: 0px auto;
  text-align: center;
}
.content img {
  width: 80%;
}
.text-color-main{
  color: #026270;
}

</style>
